<template>
  <div class="mt-6 space-y-3">
    <div>
      <label class="text-sm text-gray-900 dark:text-white">How difficult was this?</label>
      <!-- <span class="block text-xs text-gray-400">Feedback is important for personalized review.</span> -->
    </div>

    <div class="w-full p-4 rounded-lg shadow-lg bg-gradient-to-r bg-opacity from-red-200 dark:from-red-900 to-green-200 dark:to-green-900 dark:bg-gray-800">
      <input type="range" step="0.01" min="0" max="5" class="w-full h-2 rounded outline-none appearance-none slider bg-gradient-to-r from-red-300 to-green-300 dark:from-red-800 dark:to-green-800 slider-thumb" v-model="feedbackValue" @input="feedbackValueRt" @change="difficultyFeedback" />
      <div class="grid justify-between grid-cols-5 mt-2 text-xs font-semibold text-center cursor-pointer sm:text-sm">
        <div @click="this.feedbackValue = 0" class="text-red-700 dark:text-red-400">Very Hard</div>
        <div @click="this.feedbackValue = 1.5" class="text-red-600 dark:text-red-300">Hard</div>
        <div @click="this.feedbackValue = 2.5" class="text-white">OK</div>
        <div @click="this.feedbackValue = 3.5" class="text-green-600 dark:text-green-300">Easy</div>
        <div @click="this.feedbackValue = 5" class="text-green-700 dark:text-green-400">Very Easy</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  setup(props, { emit }) {
    const feedbackValue = ref("");
    function difficultyFeedback() {
      emit("difficultyFeedback", feedbackValue.value);
    }
    return { feedbackValue, difficultyFeedback };
  },
};
</script>
<style>
.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background: white;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 30px;
  height: 30px;
  background: white;
  cursor: pointer;
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>